// ここからDawnのコードに追加
// plus/minusボタンの実装。
//
// 以前は document.querySelector('#quantity' / '#btn-plus' / '#btn-minus') で
// ページ内の最初の1つだけを単一取得していたため、同じidを持つ数量ステッパーが
// 複数存在すると（例: main-product.liquid と main-product_set.liquid が同じ
// #quantity/#btn-plus/#btn-minus を使う、あなたへのおすすめモーダルのように
// 別の数量ステッパーがページ内に増える、等）、常に最初の1つだけが反応し、
// 他のステッパーが動かない/意図しないステッパーが動くバグの原因になっていた。
//
// [data-quantity-selector] を持つ要素ごとに forEach でスコープし、それぞれの
// コンテナ内だけで .btn-minus / .btn-plus / input[type=number] を解決することで、
// ページ内・モーダル内に何個ステッパーが存在しても互いに影響せず独立して動く。
document.querySelectorAll('[data-quantity-selector]').forEach((container) => {
  const quantityElement = container.querySelector('input[type="number"]');
  const plusButton = container.querySelector('.btn-plus');
  const minusButton = container.querySelector('.btn-minus');

  if (!quantityElement || !plusButton || !minusButton) return;

  const quantityChange = (e) => {
    if (e.target === plusButton) {
      quantityElement.stepUp(1);
    } else {
      quantityElement.stepDown(1);
    }
  };

  plusButton.addEventListener('click', quantityChange);
  minusButton.addEventListener('click', quantityChange);
});
